module.exports = __webpack_public_path__ + "media/img/ms-icon-310x310-675d5dd1620266744241b4a87e862d4d.png";